import { render, staticRenderFns } from "./PaymentPending.vue?vue&type=template&id=2c9d6e69&scoped=true"
import script from "./PaymentPending.vue?vue&type=script&lang=js"
export * from "./PaymentPending.vue?vue&type=script&lang=js"
import style0 from "./PaymentPending.vue?vue&type=style&index=0&id=2c9d6e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9d6e69",
  null
  
)

export default component.exports